module.exports = __webpack_public_path__ + "static/member-2-2d599d47e3b020e274e0a619a792256a.png";